var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { Inject, Debounce } from "~/core/decorator";
var TemplateService = /** @class */ (function () {
    function TemplateService() {
    }
    /**
     * 模板按条件查询
     */
    TemplateService.prototype.getTemplatesByCondition = function (data, page, sort) {
        return this.netService.send({
            server: domainService.templateController.getTemplatesByCondition,
            data: data,
            page: page,
            sort: sort
        });
    };
    /**
     * 根据模板类别获取模板列表
     * @param templateCatogory 模板类别
     */
    TemplateService.prototype.getTemplateByCatogory = function (collectorStyle) {
        return this.netService.send({
            server: domainService.templateController.getTemplateByCatogory,
            data: {
                collectorStyle: collectorStyle
            }
        });
    };
    /**
     * 新增模板信息
     */
    TemplateService.prototype.createTemplate = function (data) {
        return this.netService.send({
            server: domainService.templateController.createTemplate,
            data: {
                id: data.id,
                collectorStyle: data.collectorStyle,
                templateCategory: data.templateCategory,
                templateName: data.templateName,
                templateStatus: data.templateStatus,
                companyCode: data.companyCode,
                templateCode: data.templateCode,
                templateContent: data.templateContent,
                overduePeriod: data.overduePeriod,
                isDefault: data.isDefault,
                distributeType: data.distributeType,
            }
        });
    };
    /**
     * 更新模板信息
     */
    TemplateService.prototype.updateTemplate = function (data) {
        return this.netService.send({
            server: domainService.templateController.updateTemplate,
            data: {
                templateStyle: data.templateStyle,
                templateType: data.templateType,
                templateName: data.templateName,
                templateStatus: data.templateStatus,
                companyCode: data.companyCode,
                templateCode: data.templateCode,
                isDefault: data.isDefault,
                messageContent: data.messageContent,
                id: data.id,
                distributeType: data.distributeType,
            }
        });
    };
    /**
     * 根据id删除模板
     */
    TemplateService.prototype.deleteTemplateById = function (id) {
        return this.netService.send({
            server: domainService.templateController.deleteTemplateById,
            data: {
                id: id
            }
        });
    };
    /**
     * 根据模板形式查询启用的模板
     */
    TemplateService.prototype.getTemplatesByStyle = function (data) {
        return this.netService.send({
            server: domainService.templateController.getTemplatesByStyle,
            data: {
                style: data
            }
        });
    };
    /**
     * 根据逾期阶段查询模板
     */
    TemplateService.prototype.getTemplateByOverduePeriod = function (data) {
        return this.netService.send({
            server: domainService.templateController.getTemplateByOverduePeriod,
            data: data
        });
    };
    /**
     * 根据适用部门搜索合同模板
     */
    TemplateService.prototype.getTemplateByDistributeType = function (data) {
        return this.netService.send({
            server: domainService.templateController.getTemplateByDistributeType,
            data: data
        });
    };
    /**
     * 生成合同
     */
    TemplateService.prototype.createContractInfo = function (data) {
        return this.netService.send({
            server: domainService.templateController.createContractInfo,
            data: data
        });
    };
    /**
     * 查询案件合同列表
     */
    TemplateService.prototype.getContractInfoByCaseId = function (data) {
        return this.netService.send({
            server: domainService.templateController.getContractInfoByCaseId,
            data: {
                caseId: data
            }
        });
    };
    __decorate([
        Inject()
    ], TemplateService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], TemplateService.prototype, "createTemplate", null);
    __decorate([
        Debounce()
    ], TemplateService.prototype, "updateTemplate", null);
    __decorate([
        Debounce()
    ], TemplateService.prototype, "deleteTemplateById", null);
    __decorate([
        Debounce()
    ], TemplateService.prototype, "createContractInfo", null);
    return TemplateService;
}());
export { TemplateService };
